module.exports = __webpack_public_path__ + "static/media/Le_Xuan_An.16a4940c.jpg";